import { BoxProps } from '../components/Box/types';

export const flexDirection = (props: BoxProps): string => {
  if (props.flexDirection) return props.flexDirection;
  return props.row ? 'row' : 'column';
};

export const webkitOverflowFix = ({ overflowY }: BoxProps): string => {
  if (overflowY === 'auto' || overflowY === 'scroll') {
    return '-webkit-overflow-scrolling: touch;';
  }
  return '';
};
